exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".single-execution-details__configure {\n  margin: 0 0 5px 1em;\n}\n", ""]);

